import { Grid2 as Grid, Typography, Box } from '@mui/material';
import ReportTimeByAssugmentCharts from './ReportTimeByAssugmentCharts/ReportTimeByAssugmentCharts';
import AdditionalReportedTimeSection from './WeeklyLoggedTimeChart/AdditionalReportedTimeSection';
import WeeklyLoggedTimeChart from './WeeklyLoggedTimeChart/WeeklyLoggedTimeChart';
import { Alert } from 'framework/ui/mui-builder';
import { useShowContext } from 'framework/show';

const ReportedHoursAnalysisContent = () => {
  const { data } = useShowContext();
  const { weeklyChartData, projectChartData } = data.getData();

  return (
    <Box pb={2}>
      <Typography variant="h4" mb={2.5} color="primary" borderBottom="1px solid " borderColor="border.separator">
        Reported hours analysis
      </Typography>

      {!weeklyChartData?.length || !projectChartData?.length ? (
        <Alert sx={{ alignItems: 'center' }} color="info">
          <Typography variant="body2">No time reports</Typography>
        </Alert>
      ) : (
        <Grid container columnGap="10px" flexWrap={{ sx: 'wrap', md: 'nowrap' }}>
          <Grid size={{ xs: 12, md: 6 }}>
            <WeeklyLoggedTimeChart />
            <AdditionalReportedTimeSection />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <ReportTimeByAssugmentCharts />
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default ReportedHoursAnalysisContent;
